// extracted by mini-css-extract-plugin
export var drawer = "OtpVerification-module--drawer--e7545";
export var errorMessage = "OtpVerification-module--errorMessage--af1d2";
export var hasError = "OtpVerification-module--hasError--3e844";
export var info = "OtpVerification-module--info--5fb10";
export var input = "OtpVerification-module--input--33d9e";
export var inputWrapper = "OtpVerification-module--inputWrapper--2dc09";
export var isExpanded = "OtpVerification-module--isExpanded--59644";
export var smallSupportLink = "OtpVerification-module--smallSupportLink--ef030";
export var supportLink = "OtpVerification-module--supportLink--3b4e3";
export var unsetInput = "OtpVerification-module--unsetInput--97156";
export var verifyButton = "OtpVerification-module--verifyButton--15ebb";
export var verifyEmailButtonContainer = "OtpVerification-module--verifyEmailButtonContainer--16022";
export var verifyPhoneButtonContainer = "OtpVerification-module--verifyPhoneButtonContainer--171af";